export default "__VITE_ASSET__13444006__"